import { render } from "./TermsView.vue?vue&type=template&id=55c0996b&scoped=true"
import script from "./TermsView.vue?vue&type=script&lang=js"
export * from "./TermsView.vue?vue&type=script&lang=js"

import "./TermsView.vue?vue&type=style&index=0&id=55c0996b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c0996b"]])

export default __exports__